import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M11.518 2.214a.75.75 0 01.786 0l9.75 6a.75.75 0 01-.393 1.388H2.16a.75.75 0 01-.394-1.388l9.75-6zM4.81 8.102h14.2l-7.1-4.37-7.1 4.37z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.16 8.102a.75.75 0 01.75.75v7.5a.75.75 0 01-1.5 0v-7.5a.75.75 0 01.75-.75zM9.66 8.102a.75.75 0 01.75.75v7.5a.75.75 0 01-1.5 0v-7.5a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M2.16 16.352a.75.75 0 01.75-.75h8.161a.75.75 0 010 1.5h-8.16a.75.75 0 01-.75-.75zM.66 19.352a.75.75 0 01.75-.75h9.661a.75.75 0 010 1.5h-9.66a.75.75 0 01-.75-.75zM14.821 12.455v7.5h6V14.64l-2.186-2.185h-3.814zm-1.17-1.17c.21-.212.497-.33.795-.33h4.5a.75.75 0 01.53.22l2.625 2.624c.141.14.22.332.22.53v6a1.125 1.125 0 01-1.125 1.126h-6.75a1.125 1.125 0 01-1.125-1.125v-8.25c0-.299.119-.585.33-.796z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M18.946 10.955a.75.75 0 01.75.75v1.875h1.875a.75.75 0 110 1.5h-2.625a.75.75 0 01-.75-.75v-2.625a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
